import { z } from "zod";

/** Same rule as the backend's `AreaValidationRules`: at most 40 characters, no comma. */
export const AREA_NAME_MAX = 40;

export const areaNameSchema = z
  .string()
  .trim()
  .min(1, "Name is required")
  .max(AREA_NAME_MAX, `Name must be at most ${AREA_NAME_MAX} characters`)
  .refine((v) => !v.includes(","), "Name cannot contain a comma");

export const areaKindSchema = z.enum(["area", "part"]);
